import React from 'react';
import Start from "../../common/Start";

const BeneficiaryStart = () => {
    return (
        <Start neededItems={['Demographic information of the deceased', 'Assignments and/or settlement instructions (if available)']}/>
    )
};

export default BeneficiaryStart;